import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
//const [openModal, setOpenModal] = useState(false);


const $ = require("jquery");
// require("datatables.net-buttons-bs4")();
// require("datatables.net-buttons/js/buttons.flash.js")();
// require("datatables.net-buttons/js/buttons.html5.js")();
// require("datatables.net-buttons/js/buttons.print.js")();
//require("datatables.net-responsive-bs4");
//require('datatables.net')(window, $);
require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net-buttons-bs4");



const DataTable = props => {
  const TableElement = useRef(null);
  const [model, setData] = useState([]);

  const handledata = (record, e) => {
    e.preventDefault();
    setData(record);
    props.handleEdit(record);

  }
  const handleEditModel = () => {
    if (model.length === 0) {
      alert("Select a record to edit.")
    } else {
      props.handleModel(true);
      props.handleEdit(model);
    }
  }
  const handleDeleteModel = () => {
    if (model.length === 0) {
      alert("Select a record to delete.")
    } else {
      props.handleDelete(model);
    }
  }

  const handleNewModel = () => {
    props.handleResetModel();
    setData([]);
    props.handleModel(true);
  }
  // const handleCloseModel = (e) => {
  //   setOpenModel(false);
  //   props.HandleOnClose(e);
  // }
  useEffect(
    () => {
      $(TableElement.current).DataTable({
        dom: "Bfrtip",
        select: true,
        responsive: true,
        buttons: [], //["copy", "csv", "excel", "pdfHtml5", "print"]
      });
    },
    [],
    () => {
      $(TableElement.current).DataTable.destroy(true);
    }
  );
  const listItems = props.TableHeader.map(data => <th key={data}>{data}</th>);

  const listRows = (props.data) ? props.data.map(data => (
    <tr key={data.id} onClick={(e) => handledata(data, e)}>
      <TableRow rowData={props.rowData} data={data} />
    </tr>
  )) : null;
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">{props.page}</li>
      </ol>
      <h1 class="page-header mb-3">{props.page}</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="panel panel-inverse">

            <button type="button" style={{ marginLeft: 10, marginTop: 5 }}
              onClick={handleNewModel}
              data-toggle="modal"
              className="btn btn-info"
            > New
            </button>
            <button type="button" style={{ marginLeft: 10, marginTop: 5 }}
              onClick={handleEditModel}
              data-toggle="modal"
              className="btn btn-success"
            > Edit
            </button>
            <button type="button" style={{ marginLeft: 10, marginTop: 5 }}
              onClick={handleDeleteModel}
              data-toggle="modal"
              className="btn btn-danger"
            > Delete
            </button>

            <div className="panel-body">
              <table
                className="table table-striped table-bordered responsive nowrap"
                ref={TableElement} width="100%"
              >
                <thead>
                  <tr>{listItems}</tr>
                </thead>
                <tbody>{listRows}</tbody>
                <tfoot>
                  <tr>{listItems}</tr>
                </tfoot>
              </table>
            </div>


            {props.children}


          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;

const TableRow = props => {
  const values = props.rowData;
  return values.map((row, index) => {
    var res = row.split(".");
    let column;
    if (res.length > 1) {
      column = (props.data[res[0]] || {})[res[1]];
    } else {
      column = props.data[res[0]] || null;
    }

    return <th key={index}>{column}</th>;
  });
};
const Row = props => {
  return <th>{props.data}</th>;
};
